import type { ListingDetails } from 'app/types/listingDetails.type';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import InstantTour from 'app/shared/modules/hdp/InstantTour';
import { useContactFormAction } from '../ContactForm/useContactFormAction';
import * as styles from './tourSpoke.styles';

type TourSpokeProps = {
  onClose: () => void;
  listing?: ListingDetails;
  isModifyingTour?: boolean;
};

export const TourSpoke = ({ onClose, listing: listingProp, isModifyingTour = false }: TourSpokeProps) => {
  const reduxListing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);
  const listing = listingProp ?? reduxListing ?? undefined;
  const { openContactForm } = useContactFormAction(listing);

  if (!listing) {
    return null;
  }

  return (
    <div className={styles.tourSpokeContainer}>
      <InstantTour isModifyingTour={isModifyingTour} onHidePopup={onClose} onActionPopup={openContactForm} />
    </div>
  );
};
